export interface WrapperMessage {
    action: Action;
    data: OperatorData;
}

export enum Action {
    enableAudio = "enableAudio",
    disableAudio = "disableAudio",
    updateBalance = "updateBalance",
    getOperatorInformation = "getOperatorInformation",
    balanceTooLow = "balanceTooLow",
    isWrapperActive = "isWrapperActive",
    getScreenSize = "getScreenSize",
    balancesHasChanged = "balancesHasChanged",
    pauseGame = "pauseGame",
    resumeGame = "resumeGame",
    wrapperActivityChanged = "wrapperActivityChanged",
    gameLoadingStarted = "gameLoadingStarted",
    gameLoadingEnded = "gameLoadingEnded",
    stakeUpdate = "stakeUpdate",
    balancesUpdate = "balancesUpdate",
    winningsUpdate = "winningsUpdate",
    loadProgressUpdate = "loadProgressUpdate",
    gameRoundEnded = "gameRoundEnded",
    gotoDepositPage = "gotoDepositPage",
    gotoAccountsPage = "gotoAccountsPage",
    gameRoundStarted = "gameRoundStarted",
    exitGame = "exitGame",
    openPaytable = "openPaytable",
    openHelp = "openHelp",
    openPreferences = "openPreferences",
    openAbout = "openAbout",
    menuDialogueOpened = "menuDialogueOpened",
    menuClosed = "menuDialogueClosed",
    betDialogueOpened = "betDialogueOpened",
    betDialogueClosed = "betDialogueClosed",
    autospinMenuOpened = "autospinDialogueOpened",
    autospinMenuClosed = "autospinDialogueClosed",
    paytableDialogueOpened = "paytableDialogueOpened",
    paytableDialogueClosed = "paytableDialogueClosed",
    insufficientFunds = "insufficientFunds",
    bonusGameRecovering = "bonusGameRecovering",
    enableFeatureMode = "enableFeatureMode",
    disableFeatureMode = "disableFeatureMode",
    gamePopupShown = "gamePopupShown",
    gamePopupHidden = "gamePopupHidden",
    force = "force",
    gameError = "gameError"
}

export enum UIElements {
    homeButton = "homeButton",
    depositPageButton = "depositPageButton",
    accountsButton = "accountsPageButton"
}

export enum UISettingsButtons {
    RULES_BUTTON = "rules",
    DEPOSIT_BUTTON = "deposit",
    ACCOUNT_BUTTON = "account",
    HISTORY_BUTTON = "history",
    QUIT_BUTTON = "quit"
}

export enum UIDenomDisplayType {
    denom = "denom",
    multiplier = "multiplier",
}

export enum UIBetSettingsType {
    denom = "denom",
    totalBet = "totalBet",
    lines = "lines",
}

export interface OperatorData {
    active: boolean;
    bonus: number;
    cash: number;
    operator: {
        id: number;
        name: string;
    };
    ui: Partial<UI>;
    name: string;
}

export interface UI {
    maxBet: string;
    displayClock: string;
    disableFullscreen: boolean;
    slamStop: string;
    minStopDuration: number;
    denomDisplay: string;
    betSettings: string;
    autoplay: AgsAutoplayConfigSchema;
    hideBalance: boolean;
    hideBet: boolean;
    hideDenom: boolean;
    hideJackpotWording: string;
    removeFromCurrencyString: string;
    requestTimeoutDuration: number;
    displayWholeStakeAsDecimal: string;
    displayDecimalDenomAsWholeNumber: string;
    displayType: string;
    disableSpaceToSpin: boolean;
    hideEnableSoundsPrompt: string;
    stopOnFeatureWin: string;
    enabledSettingsButtons: string[];
    layouts: { desktop: UIElements[]; mobile: UIElements[]; };
    isSocial: boolean;
}

export interface AgsAutoplayConfigSchema {
    numberOfRounds: AgsArrayWithDefaultConfigSchema;
    lossLimit: AgsArrayWithDefaultConfigSchema;
    totalWinLimit: AgsArrayWithDefaultConfigSchema;
    singleWinLimit: AgsArrayWithDefaultConfigSchema;
    stopOnFeatureWin: boolean;
}

export interface AgsArrayWithDefaultConfigSchema {
    defaultVal: number;
    values: number[];
    lossLimitRequired?: boolean;
}
